module.exports = __webpack_public_path__ + "img/circle.4feda944.svg";